import React, { useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';

import { Banner, Form, FormLayout, Select } from '@shopify/polaris';

import TaskNewForm from './components/TaskForm';
import TaskUpdateForm from './components/TaskUpdateForm';
import ArchiveTaskAction from './components/ArchiveTaskAction';

import PolarisFormProvider from '@shared/PolarisFormProvider';
import FormPageActions from '@shared/FormPageActions';
import ResourceLogList from "components/views/orders/components/ResourceLogList";
import EvidenceList from "components/shared/EvidenceList";

import { taskCatalogs } from 'utils/shapes';

import merge from 'lodash/merge'

const propTypes = {
  task: PropTypes.object,
  queryBrightPearlURL: PropTypes.string.isRequired,
  queryCouriersURL: PropTypes.string.isRequired,

  catalogs: taskCatalogs.isRequired,
  update: PropTypes.bool,
  couriers: PropTypes.array.isRequired,

  readOnly: PropTypes.bool,
  archiveURL: PropTypes.string,
}

const defaultProps = {
  update: false,
  readOnly: false
}

const defaultValues = {
  team_id: "",
  courier_id: "",
  address: "",
  notes: "",
  customer_task: { order_id: "", item_ids: [] },
}

const TaskFormContainer = (props) => {
  const archiveRef = useRef(null);

  const initialValues = useMemo(() => {
    return props.update ? merge(defaultValues, props.task) :  merge(props.task, defaultValues);
  }, []);

  const submitMethod = props.update ? "PUT" : "POST";

  const formProps = {
    readOnly: props.readOnly,
    queryBrightPearlURL: props.queryBrightPearlURL,
    queryCouriersURL: props.queryCouriersURL,
    initialCouriers: props.couriers,

    catalogs: props.catalogs ,
  };

  console.log("props", props);

  return (
    <PolarisFormProvider
      title={I18n.t("activerecord.models.task.one")}
      defaultValues={ initialValues }
      submitURL={ props.submitURL }
      submitMethod={ submitMethod }
      paramsName="task"
      pageProps={props.page}
    >
      {(renderProps) =>
        <div>
          <Form onSubmit={renderProps.handleSubmit}>
            { props.task.archived_at &&
              <div className="mb12">
                <Banner status="info" title="Tarea archivada">
                  Se conserva como historial, fuera de la operación diaria. Archivada el { new Date(props.task.archived_at).toLocaleString('es-CR') }
                </Banner>
              </div>
            }
            { props.update ?
              <TaskUpdateForm renderProps={ renderProps } {...formProps} />
            :
              <TaskNewForm renderProps={ renderProps } {...formProps} />
            }
            {/* An archived task can no longer be edited, so there is nothing to save */}
            <FormPageActions
              onPrimaryAction={props.task.archived_at ? null : renderProps.handleSubmit}
              deleteURL={props.deleteURL}
              secondaryActions={ props.archiveURL ? [{ content: 'Archivar tarea', onAction: () => archiveRef.current?.open() }] : [] }
            />
            {/* Only the confirmation lives here; its trigger is the secondary action next to save */}
            { props.archiveURL &&
              <ArchiveTaskAction ref={ archiveRef } archiveURL={ props.archiveURL } hideButton />
            }
          
          { props.task.task_logs &&
            <ResourceLogList logs={ props.task.task_logs } />
          }
          { props.task.evidences &&
            <EvidenceList evidences={ props.task.evidences } />
          }
          </Form>

        </div>
      }
    </PolarisFormProvider>
  )
};

TaskFormContainer.propTypes = propTypes;
TaskFormContainer.defaultProps = defaultProps;

export default TaskFormContainer;